import { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment-timezone";
import socket from "../socket/socket";

const DetailedOrderLog = ({ id, showLog }) => {
  const [loading, setLoading] = useState(true);
  const [logs, setLogs] = useState([]);
  const token = localStorage.getItem("token");
  const fetchOrderLog = async () => {
    axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}order-log/detailed-log/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.code === 1) {
          setLogs(res.data.data);
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (showLog === true) {
      fetchOrderLog();
    }
  }, [id, showLog]);
  useEffect(() => {
    socket.on(`admin:ordersUpdate`, (data) => {
      if (data?.orderId?.trim() !== id) return;
      fetchOrderLog();
    });
    return () => {
      socket.off(`admin:ordersUpdate`);
    };
  }, []);
  return loading ? (
    <div className="spinner-border text-primary"></div>
  ) : logs?.length === 0 ? (
    <div className="text-center w-100">
      <img
        className="w-25 mx-auto py-20"
        src={`${process.env.REACT_APP_PUBLIC_URL}assets/media/misc/no-content.png`}
        alt="no-content"
      />
    </div>
  ) : (
    <div className="table-responsive">
      <table className="table align-middle table-row-dashed fs-6 gy-5">
        <thead>
          <tr className="text-muted fw-bold fs-7 text-uppercase gs-0">
            <th className="text-center min-w-100px text-nowrap">Status</th>
            <th className="text-center min-w-100px text-nowrap">Driver Name</th>
            <th className="text-center min-w-100px text-nowrap">
              Driver Phone Number
            </th>
            <th className="text-center min-w-100px text-nowrap">Date</th>
          </tr>
        </thead>
        <tbody className="text-gray-600 fw-semibold">
          {logs?.map((log, index) => {
            return (
              <tr key={index}>
                <td>{log?.status}</td>
                <td>{log?.driverName ?? "---"}</td>
                <td>{log?.driverPhone ?? "---"}</td>
                <td>
                  {moment(log?.createdAt)
                    .tz(process.env.REACT_APP_TIMEZONE)
                    .format("Do MMM, YYYY, HH:mm:ss")}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default DetailedOrderLog;
